import {getAllSolutionFilters} from '@/store/state/helpers';
import {formatBudget} from '@mobi-components/amex-bluesky-components';
import {Activity, UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {computed} from '@vue/composition-api';

export function usePlaceCardUtils() {
  const activeSolutionFilters = computed<Set<string>>(() => {
    const activeTags = getAllSolutionFilters()
      .filter((x) => x.value)
      .map((x) => x.name.toLowerCase());
    return new Set(activeTags);
  });

  const getActivityPrice = (activity: Activity) => {
    const isDine = activity.category === UserActivityCategoryEnum.DINING;
    const priceBound = activity.source?.content?.price_level?.lowerbound
      ? new Array(activity.source?.content?.price_level?.lowerbound).fill('$').join('')
      : '';
    const usdPrice = activity.prices?.length
      ? formatBudget(activity.prices[0].amount, activity.prices[0].currency, 'Points')
      : '';
    return (isDine && priceBound) || usdPrice;
  };

  const getActivityTags = (activity: Activity) => {
    const allTags = new Set((activity.types || []).map((y) => y.toLowerCase()));

    const matchedTags = new Set(
      Array.from(activeSolutionFilters.value as Set<string>)
        .filter((y) => allTags.has(y))
        .slice(0, 3),
    );
    const disabledTags = [...allTags].filter((y) => !matchedTags.has(y));

    const usefulDisabled = disabledTags.slice(0, 3 - matchedTags.size);

    return [...matchedTags]
      .map((y) => ({name: y, isActive: true}))
      .concat([...usefulDisabled].map((y) => ({name: y, isActive: false})));
  };

  return {
    getActivityTags,
    getActivityPrice,
    activeSolutionFilters,
  };
}
